import { useState } from 'react';
import { YStack } from 'tamagui';

import { Notice } from '../../components/notices/Notice';
import { H6Regular } from '../../components/text/Typography';

export const Notices = () => {
    const [showDismissibleNotice, setShowDismissibleNotice] = useState(true);

    return (
        <>
            <YStack gap={16}>
                <Notice
                    variant="neutral"
                    title="Neutral Notice"
                    description="This is a neutral notice with informational content."
                />
                <Notice
                    variant="positive"
                    title="Positive Notice"
                    description="This is a positive notice indicating success or good news."
                />
                <Notice
                    variant="warning"
                    title="Warning Notice"
                    description="This is a warning notice to alert users about potential issues."
                />
                <Notice
                    variant="danger"
                    title="Danger Notice"
                    description="This is a danger notice for critical errors or important warnings."
                />
            </YStack>
            <YStack gap={16}>
                <H6Regular>Dismissible Notice</H6Regular>
                {showDismissibleNotice && (
                    <Notice
                        variant="neutral"
                        title="Dismissible Notice"
                        description="This notice can be dismissed using the X button in the top right corner. Click the X to dismiss it."
                        onDismiss={() => {
                            setShowDismissibleNotice(false);
                        }}
                    />
                )}
            </YStack>
            <YStack gap={16}>
                <H6Regular>Notices with Actions</H6Regular>
                <Notice
                    variant="neutral"
                    title="Notice with Underlined Action"
                    description="This notice includes an action button that is underlined by default."
                    action={{
                        text: 'Learn more',
                        onPress: () => {},
                        underlined: true,
                    }}
                />
                <Notice
                    variant="positive"
                    title="Notice with Non-Underlined Action"
                    description="This notice includes an action button that is not underlined."
                    action={{
                        text: 'View details',
                        onPress: () => {},
                        underlined: false,
                    }}
                />
            </YStack>
        </>
    );
};
